import React from 'react';
import styles from '../../index.module.scss';
import Button from 'components/Button';
import Icon from 'components/Icon';
import toolsEventMap from 'components/ReaderTools/toolsEventMap';

import { withTranslation } from 'react-i18next';

const InteractiveObjectContentCommandComponent = ({ t, type, command, canvasSVGObject }) => {
    return (
        <Button
            key={type}
            onClick={() => command && command.execute({ canvasSVGObject })}
            title={t(toolsEventMap[type].title)}
        >
            <Icon name={toolsEventMap[type].icon} />
            <div className={styles.text}>{t(toolsEventMap[type].title)}</div>
        </Button>
    );
};

export default withTranslation()(InteractiveObjectContentCommandComponent);
